import React, { useContext } from "react";
import CallSummary from "./callSummary";
import { Text } from "rizzui/typography";
import { Flex } from "rizzui/flex";
import { Link } from "react-router";

import useFetchData from "../../hooks/useFetchData";
import DataTable from "../../component/table";
import RightDrawer from "../../layout/appLayout/rightDrawer";
import { useDrawer } from "../../hooks/useDrawer";
import { BasicColumns } from "../calls/column";
import { CallRecord } from "../../lib/types";
import CallDrawer from "../../component/callDrawer";

export default function CallReport({ empty }: { empty?: boolean }) {
  const { data, error, isLoading } = useFetchData({ dataType: "calls" });
  const { openDrawer, closeDrawer } = useDrawer();

  const orderData: CallRecord[] = Array(10).fill({
    _id: "call_12345",
    user_id: "user_67890",
    lead_id: "lead_54321",
    campaign_id: "campaign_98765",
    campaign_details: {
      _id: "campaign_98765",
      user_id: "user_67890",
      campaign_name: "Test Campaign",
      campaign_type: "Email",
      campaign_description: "A test campaign for demonstration purposes.",
      campaign_level: "Beginner",
      campaign_creation_percent_complete: 100,
      is_active: true,
      is_paused: false,
      is_completed: false,
      is_deleted: false,
      knowledge_base: [],
      createdAt: "2023-01-01T00:00:00Z",
      updatedAt: "2023-01-02T00:00:00Z",
      __v: 0,
      ai_agent_id: "agent_123",
      ai_agent_name: "Test Agent",
      ai_agent_role: "Assistant",
      availability: "Available",
    },
    lead_details: {
      _id: "lead_54321",
      user_id: "user_67890",
      campaign_id: "campaign_98765",
      firstname: "John",
      lastname: "Doe",
      fullname: "John Doe",
      title: "Manager",
      country_code: "US",
      country_name: "United States",
      email: "john.doe@example.com",
      phone_number: "+1234567890",
      formatted_phone: "+1 (234) 567-890",
      actual_phone_number: "1234567890",
      phone_extension: "123",
      address: "123 Main St",
      city: "New York",
      company_website: "https://example.com",
      company_name: "Example Inc.",
      company_size: "50-100",
      company_industry: "Technology",
      lead_stage: "Contacted",
      source: "LinkedIn",
      is_active: true,
      is_deleted: false,
      is_queued: false,
      createdAt: "2023-01-01T00:00:00Z",
      updatedAt: "2023-01-02T00:00:00Z",
      __v: 0,
    },
    schedule_time: [
      {
        day: "Monday",
        slots: [
          {
            start: "09:00",
            end: "10:00",
            _id: "slot_1",
          },
        ],
        _id: "schedule_1",
      },
    ],
    call_status: "Completed",
    phone_number: "+1234567890",
    createdAt: "2023-01-01T00:00:00Z",
    updatedAt: "2023-01-02T00:00:00Z",
    __v: 0,
    call_platform: "Twilio",
    call_platform_id: "platform_123",
    call_platform_result: {
      id: "result_123",
      assistantId: "assistant_456",
      type: "Call",
      createdAt: "2023-01-01T00:00:00Z",
      updatedAt: "2023-01-02T00:00:00Z",
      orgId: "org_789",
      cost: 10.5,
      phoneNumber: {
        assistantId: "assistant_456",
        twilioAuthToken: "auth_token",
        twilioAccountSid: "account_sid",
        twilioPhoneNumber: "+1234567890",
      },
      customer: {
        name: "John Doe",
        number: "+1234567890",
        extension: "123",
        numberE164CheckEnabled: true,
      },
      status: "Success",
      schedulePlan: {
        latestAt: "2023-01-01T10:00:00Z",
        earliestAt: "2023-01-01T09:00:00Z",
      },
    },
  });

  return (
    <div className="mb-6 gap-[32px] grid grid-cols-1 md:grid-cols-10 lg:grid-cols-9 2xl:gap-8">
      <div className="@4xl:col-span-4 md:col-span-4 lg:col-span-3">
        <Text className="font-switzer font-[500] text-[14px] leading-[18.48px] text-[#758599] pb-[8px]">
          Reason calls ended
        </Text>
        <CallSummary
          isEmpty
          className="w-full dark:bg-[#2A2C30] border-muted border-[.5px]"
        />
      </div>

      <div className="@4xl:col-span-4 md:col-span-6 lg:col-span-6">
        <Flex className="justify-between pb-[8px]">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px] text-[#758599]">
            Call activities
          </Text>
          <Link
            to="/calls"
            className="font-switzer font-[500] text-[14px] leading-[18.48px] text-[#758599]"
          >
            View all
          </Link>
        </Flex>
        <DataTable
          isLoading={isLoading}
          columns={BasicColumns()}
          setPage={null}
          error={error}
          isDashboardEmpty={data?.data?.length === 0}
          data={empty ? orderData : data?.data?.slice(-8) ?? []}
          pageSize={null}
          meta={(row) => {
            openDrawer({
              view: <CallDrawer row={row} />,
              placement: "right",
              containerClassName: "w-full md:!w-[435px]",
            });
          }}
          defaultSort={{ id: "dateTime", desc: true }}
        />
      </div>
    </div>
  );
}
